import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';
import PersonnelPage from './pages/PersonnelPage';
import LandmanDetailPage from './pages/LandmanDetailPage';
import ManageRatesPage from './pages/ManageRatesPage';
// import Tax1099Page from './pages/1099Page';
import PaperworkAccessPage from './pages/PaperworkAccessPage';
import ContractPayPage from './pages/ContractPayPage';
import BillingPage from './pages/BillingPage';
import EmployeePayPage from './pages/EmployeePayPage';
import ScorecardPage from './pages/ScorecardPage';
import ManageContactInfoPageFF from './pages/ManageContactInfoPage';
import ManageCommentsPage from './pages/ManageCommentsPage';
import PdfFormFiller from 'src/components/personnel/components/ScoreCardEntry';
import EmployeeBenefitsPage from './pages/EmployeeBenefitsPage';
import EmployeeInsuranceHistoryPage from './pages/EmployeeInsuranceHistoryPage';
import EmployeeBenefitsHistoryPage from './pages/EmployeeBenefitsHistoryPage';
import BenefitRatesPage from './pages/BenefitRatesPage';
import PersonnelOverviewPage from './pages/PersonnelOverviewPage';
import CheckRegisterPage from './pages/CheckRegisterPage';
import EmployeePayrollPage from './pages/EmployeePayrollPage';
import CommissionPage from './pages/CommissionPage';
import DirectorCommissionPage from './pages/DirectorCommissionPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="personnel" path="/personnel/home" component={PersonnelPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="personnel" path="/personnel/:id/home" component={PersonnelPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="paperwork" path="/personnel/paperwork" component={PaperworkAccessPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="benefits" path="/personnel/:id/paperwork" component={PaperworkAccessPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="scorecard" path="/personnel/scorecard" component={ScorecardPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="scorecard" path="/personnel/:id/scorecard" component={ScorecardPage} isLoggedIn={isLoggedIn} />,
        // <RoutePrivate key="1099" path="/personnel/1099" component={Tax1099Page} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="contract-pay" path="/personnel/contract-pay" component={ContractPayPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="contract-pay" path="/personnel/:id/contract-pay" component={ContractPayPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="billing" path="/personnel/billing" component={BillingPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="billing" path="/personnel/:id/billing" component={BillingPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="employee-pay" path="/personnel/employee-pay" component={EmployeePayPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="employee-pay" path="/personnel/:id/employee-pay" component={EmployeePayPage} isLoggedIn={isLoggedIn} />,

        <RoutePrivate key="employee-benefits" path="/personnel/employee-benefits" component={EmployeeBenefitsPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="employee-benefits" path="/personnel/:id/employee-benefits" component={EmployeeBenefitsPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="insurance-history" path="/personnel/insurance-history" component={EmployeeInsuranceHistoryPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="insurance-history" path="/personnel/:id/insurance-history" component={EmployeeInsuranceHistoryPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="benefits-history" path="/personnel/benefits-history" component={EmployeeBenefitsHistoryPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="benefits-history" path="/personnel/:id/benefits-history" component={EmployeeBenefitsHistoryPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="rates" path="/personnel/:id/overview" component={PersonnelOverviewPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="rates" path="/personnel/overview" component={PersonnelOverviewPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="rates" path="/personnel/rates" component={BenefitRatesPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="rates" path="/personnel/:id/rates" component={BenefitRatesPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate
            key="landman-manage-contact-info"
            path="/landmen/:id/manage-contact-info"
            component={ManageContactInfoPageFF}
            isLoggedIn={isLoggedIn}
        />,
        <RoutePrivate exact={true} key="landman-manage-rates" path="/landmen/:id/manage-rates" component={ManageRatesPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="landman-detail" path="/landmen/:id" component={LandmanDetailPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate
            exact={true}
            key="landman-manage-comments"
            path="/landmen/:id/manage-comments"
            component={ManageCommentsPage}
            isLoggedIn={isLoggedIn}
        />,
        <RoutePrivate key="project" path="/personnel/scorecardentry" component={PdfFormFiller} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="check-register" path="/personnel/check-register" component={CheckRegisterPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="employee-payroll" path="/personnel/employee-payroll" component={EmployeePayrollPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="commission" path="/personnel/commission" component={CommissionPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="director-commission" path="/personnel/director-commission" component={DirectorCommissionPage} isLoggedIn={isLoggedIn} />
    ];
}



// WEBPACK FOOTER //
// ./src/components/personnel/Personnel.Routes.tsx